import React from 'react';
import { HomeProps } from '../views/Home/Home';
import { SectionTransformer } from '@jbhi-fi/components/src/Contentful/transformers/SectionTransformer';
import { SectionProps } from '@jbhi-fi/components/src/Section/Section';
import { ContentfulContentHubHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { HeroBlockProps } from '@jbhi-fi/components/src/HeroBlock';
import { HeroTile } from '@jbhi-fi/components/src/HeroTile/HeroTile';
import { CardTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CardTransformer';
import { HeroBlockTransformer } from '@jbhi-fi/components/src/Contentful/transformers/HeroBlockTransformer';
import { LaunchTilesTransformer } from '@jbhi-fi/components/src/Contentful/transformers/LaunchTilesTransformer';
import { ThemeTransformer } from '@jbhi-fi/components/src/Contentful/transformers/ThemeTransformer';
import { CarouselTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CarouselTransformer/CarouselTransformer';
import { ShowcaseCardTransformer } from '@jbhi-fi/components/src/Contentful/transformers/ShowcaseCardTransformer';

export const contentfulApiHomepageToHomeProps = (homepage: ContentfulContentHubHomepage): HomeProps => {
  const { fields } = homepage;
  return {
    heading: fields?.heading,
    subText: fields?.subText,
    promoCardCarousel: fields?.promoCardCarousel
      ? CarouselTransformer.toListingBlockPromoCardCarouselProps(fields.promoCardCarousel)
      : undefined,
    showcaseCards: fields?.showcaseCards
      ?.map(card => ShowcaseCardTransformer.toShowcaseCardProps(card, fields.heroTheme))
      ?.filter(card => !!(card.heading && card.url && card.image?.props?.src && card.subText)),
    type: fields?.type,
    hero: fields?.heroBlock?.fields ? homepageToHeroBlockProps(homepage) : undefined,
    contentPalette: fields?.heroTheme ? ThemeTransformer.toContentThemeVariables(fields.heroTheme).palette : undefined,
    sections: fields?.sections
      ?.map(
        section =>
          section?.fields &&
          SectionTransformer.toSectionPropsFromContentHubHomePage({ entry: section, isContentHubHomePage: true })
      )
      ?.filter(Boolean) as Array<SectionProps>,
  };
};

const homepageToHeroBlockProps = ({ fields }: ContentfulContentHubHomepage): HeroBlockProps | undefined => {
  if (!fields) return undefined;

  const launchTileHoverPalette = ThemeTransformer.toContentThemePalette(fields.launchTileHoverTheme);

  return {
    ...HeroBlockTransformer.toHeroBlockProps(fields.heroBlock, {
      launchTilesProps: fields.launchTiles
        ? {
            tiles: fields.launchTiles?.map(launchTile =>
              LaunchTilesTransformer.toLaunchTileProps(launchTile, { hoverPalette: launchTileHoverPalette })
            ),
          }
        : undefined,
      heroBlockCta: fields.miniBanner?.fields ? <HeroTile {...CardTransformer.toCardProps(fields.miniBanner)} /> : null,
    }),
  };
};
